import { createCubicBezier, CubicBezier } from './Bezier';
import { getSegmentCoords, transformSegment } from './Segment';
export class Path {
    constructor(segments) {
        Object.defineProperty(this, "segments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.segments = (segments !== null && segments !== void 0 ? segments : []).concat();
    }
    getSegments() {
        return this.segments.concat();
    }
    getCurves() {
        const { segments } = this;
        const curves = [];
        for (let i = 0; i < segments.length - 1; i += 1) {
            curves.push(createCubicBezier(segments[i], segments[i + 1]));
        }
        return curves;
    }
    bbox() {
        const { segments } = this;
        const { min, max } = Math;
        let minX = Number.MAX_SAFE_INTEGER;
        let minY = Number.MAX_SAFE_INTEGER;
        let maxX = Number.MIN_SAFE_INTEGER;
        let maxY = Number.MIN_SAFE_INTEGER;
        for (let i = 0; i < segments.length - 1; i += 1) {
            const bezier = new CubicBezier(segments[i], segments[i + 1]);
            // bezier bbox
            const bbox = bezier.bbox();
            minX = min(minX, bbox.x.min);
            maxX = max(maxX, bbox.x.max);
            minY = min(minY, bbox.y.min);
            maxY = max(maxY, bbox.y.max);
        }
        return {
            x: { min: minX, max: maxX },
            y: { min: minY, max: maxY },
        };
    }
    transform(matrix) {
        this.segments = this.segments.map(segment => transformSegment(segment, matrix));
    }
    getNearestLocation(point) {
        let minDist = Infinity;
        let minLoc = null;
        this.getCurves().forEach(curvePoints => {
            const curve = new CubicBezier(curvePoints);
            const loc = curve.getNearestLocation(point);
            if (loc.distance < minDist) {
                minDist = loc.distance;
                minLoc = loc;
            }
        });
        return minLoc;
    }
    getPathData(precision = 4) {
        // NOTE: #setPathData() is defined in PathItem.
        const { segments } = this;
        const { length } = segments;
        const coords = new Array(6);
        let first = true;
        let curX;
        let curY;
        let prevX;
        let prevY;
        let inX;
        let inY;
        let outX;
        let outY;
        const parts = [];
        precision = precision !== null && precision !== void 0 ? precision : 5;
        const multiplier = Math.pow(10, precision);
        const number = (val) => precision < 16 ? Math.round(val * multiplier) / multiplier : val;
        const pair = (val1, val2) => number(val1) + ',' + number(val2);
        const addSegment = (segment) => {
            getSegmentCoords(segment, coords);
            curX = coords[0];
            curY = coords[1];
            if (first) {
                parts.push('M' + pair(curX, curY));
                first = false;
            }
            else {
                inX = coords[2];
                inY = coords[3];
                // if (
                //     inX === curX &&
                //     inY === curY &&
                //     outX === prevX &&
                //     outY === prevY
                // ) {
                //     // l = relative lineto:
                //     if (!skipLine) {
                //         const dx = curX - prevX;
                //         const dy = curY - prevY;
                //         parts.push(
                //             dx === 0
                //                 ? 'v' + f.number(dy)
                //                 : dy === 0
                //                 ? 'h' + f.number(dx)
                //                 : 'l' + f.pair(dx, dy)
                //         );
                //     }
                // } else {
                // c = relative curveto:
                parts.push('c' +
                    pair(outX - prevX, outY - prevY) +
                    ' ' +
                    pair(inX - prevX, inY - prevY) +
                    ' ' +
                    pair(curX - prevX, curY - prevY));
                // }
            }
            prevX = curX;
            prevY = curY;
            outX = coords[4];
            outY = coords[5];
        };
        if (!length) {
            return '';
        }
        for (let i = 0; i < length; i += 1) {
            addSegment(segments[i]);
        }
        // parts.push('z');
        return parts.join('');
    }
    toArray() {
        return this.segments.map(segment => [
            segment.handleIn.toObject(),
            segment.point.toObject(),
            segment.handleOut.toObject(),
        ]);
    }
}
